import React, { useState, useEffect } from 'react';
import { UserPlus, UserMinus } from 'lucide-react';

export default function FollowButton({ targetUserId, currentUserId, targetUserName }) {
  const [isFollowing, setIsFollowing] = useState(false);
  const [loading, setLoading] = useState(false);

  const API_URL = process.env.REACT_APP_API_URL || '';

  useEffect(() => {
    checkFollowStatus();
  }, [targetUserId, currentUserId]);

  const checkFollowStatus = async () => {
    if (!currentUserId || !targetUserId || currentUserId === targetUserId) {
      return;
    }

    try {
      const response = await fetch(
        `${API_URL}/api/users/${currentUserId}/following/${targetUserId}`
      );
      const data = await response.json();

      if (data.success) {
        setIsFollowing(data.isFollowing);
      }
    } catch (error) {
      console.error('Error checking follow status:', error);
    }
  };

  const handleFollowToggle = async () => {
    if (!currentUserId || !targetUserId) {
      alert('Please login to follow users');
      return;
    }

    if (currentUserId === targetUserId) {
      return; // Can't follow yourself
    }

    setLoading(true);

    try {
      const url = `${API_URL}/api/users/${targetUserId}/follow`;
      const method = isFollowing ? 'DELETE' : 'POST';

      console.log('Follow request:', { url, method, currentUserId, targetUserId });

      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ followerId: currentUserId }),
      });

      console.log('Follow response status:', response.status);
      const data = await response.json();
      console.log('Follow response data:', data);

      if (data.success) {
        setIsFollowing(!isFollowing);
      } else {
        console.error('Follow failed:', data.error);
        alert(data.error || 'Failed to update follow status');
      }
    } catch (error) {
      console.error('Error toggling follow:', error);
      alert(`Failed to update follow status: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Don't show follow button for own profile
  if (!currentUserId || currentUserId === targetUserId) {
    return null;
  }

  return (
    <button
      onClick={handleFollowToggle}
      disabled={loading}
      className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-colors ${
        isFollowing
          ? 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          : 'bg-blue-600 text-white hover:bg-blue-700'
      } ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
    >
      {isFollowing ? (
        <>
          <UserMinus className="w-4 h-4" />
          <span>Following</span>
        </>
      ) : (
        <>
          <UserPlus className="w-4 h-4" />
          <span>Follow</span>
        </>
      )}
    </button>
  );
}
